// Searchable dropdown of devices (or any {id, name} list) for nested form rows.
// Reads the list once from window.deviceSelectOptions (set by the consuming form view).
document.addEventListener('alpine:init', () => {
  Alpine.data('deviceSelect', ({ initialId, initialName, fieldName }) => ({
    open: false,
    search: '',
    selectedId: initialId || '',
    selectedName: initialName || '',
    fieldName,

    devices() {
      return window.deviceSelectOptions || [];
    },

    filtered() {
      if (!this.search) return this.devices();
      const q = this.search.toLowerCase();
      return this.devices().filter(d => d.name && d.name.toLowerCase().includes(q));
    },

    label() {
      return this.selectedName || 'Select device (optional)';
    },

    select(device) {
      this.selectedId = device.id;
      this.selectedName = device.name;
      this.open = false;
      this.search = '';
    },

    clear() {
      this.selectedId = '';
      this.selectedName = '';
    },

    toggle() {
      this.open = !this.open;
    },

    close() {
      this.open = false;
    }
  }));
});
